export interface QrCodeSettings {
  qr_settings_id?: string;
  code_color?: string;
  background_color?: string;
  image_format?: ImageFormat | string;
  width?: number;
  dpi?: number;
  margin?: number;
  center_logo_url?: string;
  code_pattern?: number;
  finder_pattern?: number;
  finder_pattern_color?: string;
  background_image_url?: string;
  code_pattern_url?: string;
  finder_eye_color?: string;
}

export enum ImageFormat {
  PNG = 'png',
  JPEG = 'jpeg',
  SVG = 'svg',
}

export interface LinkifierQrCodeSettings extends QrCodeSettings {
  qr_settings_id?: string;
}
